import { SessionState } from '../types/UserTypes'

export const inPov = (session: SessionState | undefined) => {
  return session?.portalPreferences?.enablePov === true
}
